import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { format, differenceInDays } from "date-fns";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Currency formatting function
export const formatCurrency = (amount, currencyCode = 'INR') => {
  // Get currency symbol
  const currencySymbols = {
    'INR': '₹',
    'USD': '$',
    'EUR': '€',
    'GBP': '£',
    'AED': 'د.إ',
    'SGD': 'S$',
    'AUD': 'A$',
    'CAD': 'C$'
  };
  
  const symbol = currencySymbols[currencyCode] || '₹';
  
  // For INR, use Indian number system (Lakhs, Crores)
  if (currencyCode === 'INR') {
    if (amount >= 10000000) return `${symbol}${(amount / 10000000).toFixed(1)}Cr`;
    if (amount >= 100000) return `${symbol}${(amount / 100000).toFixed(1)}L`;
    return `${symbol}${(amount / 1000).toFixed(0)}K`;
  }
  
  // For other currencies, use international format (K, M, B)
  if (amount >= 1000000000) return `${symbol}${(amount / 1000000000).toFixed(1)}B`;
  if (amount >= 1000000) return `${symbol}${(amount / 1000000).toFixed(1)}M`;
  if (amount >= 1000) return `${symbol}${(amount / 1000).toFixed(0)}K`;
  return `${symbol}${amount.toFixed(0)}`;
};

// Date formatting with timezone support
export const formatDate = (dateString, timezone = 'Asia/Kolkata') => {
  try {
    const date = new Date(dateString);
    // Use toLocaleString with timezone
    return date.toLocaleDateString('en-US', {
      timeZone: timezone,
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch (error) {
    return dateString;
  }
};

// Calculate days until event
export const calculateDaysUntil = (dateString) => {
  try {
    const days = differenceInDays(new Date(dateString), new Date());
    return Math.max(0, days);
  } catch (error) {
    return 0;
  }
};